import { Icons } from '@/components/Shares/Icons';
import { PrimeSwitch } from '@/components/Shares/PrimeSwitch';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Card, Group, Stack, Text, rem } from '@mantine/core';
export const PreferencePrivacyCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card radius={5} bg="var(--bg-400)" p={{
    base: 10,
    sm: 20
  }} h="100%">
      <Text fz={{
      base: rem(14),
      sm: rem(18)
    }} mt={10} className={gunterzBold.className}>
        {i18n._('Privacy')}
      </Text>

      <Group mt={24} justify="space-between">
        <Group c="var(--text-dark)">
          <Icons className="icon-pr-line-lock" fontSize={25} />
          <Stack gap={0}>
            <Text fz={rem(12)} tt="uppercase" fw={700} c="inherit">
              {i18n._('private profile')}
            </Text>
            <Text fz={{
            base: rem(10),
            sm: 'xs'
          }} c="inherit" w={{
            base: 233,
            sm: 479
          }}>
              {i18n._(`Other users won't be able to see your username`)}
            </Text>
          </Stack>
        </Group>
        <PrimeSwitch />
      </Group>

      <Group mt={20} justify="space-between">
        <Group c="var(--text-dark)">
          <Icons className="icon-pr-line-chart-up" fontSize={25} />
          <Stack gap={0}>
            <Text fz={rem(12)} tt="uppercase" fw={700} c="inherit">
              {i18n._('hide stats')}
            </Text>
            <Text fz={{
            base: rem(10),
            sm: 'xs'
          }} c="inherit" w={{
            base: 233,
            sm: 479
          }}>
              {i18n._(`Other users won't be able to view your wins, losses and wagered statistics`)}
            </Text>
          </Stack>
        </Group>
        <PrimeSwitch />
      </Group>
    </Card>;
};